const Cart = {
  path: '/cart',
  name: 'cart',
  component: () => import('../../views/Cart/cart.vue'),
};

module.exports = {
  Cart,
};
